import Carousel from "../components/MainCarousel"

const Home = () => {
    return (
        <div id="home">
            <Carousel/>
        </div>
    )
}

export default Home
